import React from "react";

const AddressSelectBoxEdit = ({
  className,
  OptionValue,
  onChange,
  name,
  id,
  myRef,
  validationMsg,
  defaultValue,
}) => {
  const OptionData = OptionValue.map((addressData, index) => {
    return (
      <option value={addressData.id} key={index}>
        {addressData.address}
      </option>
    );
  });
  return (
    <>
      <select
        className={className}
        name={name}
        ref={myRef}
        onChange={onChange}
        id={id}
        value={defaultValue}
      >
        {OptionData}
      </select>
      {validationMsg && (
        <>
          <span className="error_msg">{validationMsg}</span>
        </>
      )}
    </>
  );
};

export default AddressSelectBoxEdit;
